import * as actions from './configActions';

const initialState = {
    config: null,
    error: null,
    loading: false,
    initialized: false,
    updating: false,
    resetting: false,
};

const mycoreConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetch Configuration
        case actions.FETCH_MYCORE_CONFIG.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_MYCORE_CONFIG.SUCCESS: {
            const { config } = action.payload;
            return {
                ...state,
                loading: false,
                initialized: true,
                config,
                error: null,
            };
        }

        case actions.FETCH_MYCORE_CONFIG.FAILURE:
            return {
                ...state,
                loading: false,
                initialized: false,
                error: action.payload,
            };

        // Update Configuration
        case actions.UPDATE_MYCORE_CONFIG.REQUEST:
            return { ...state, updating: true, error: null };

        case actions.UPDATE_MYCORE_CONFIG.SUCCESS: {
            const { config } = action.payload;
            return {
                ...state,
                updating: false,
                config,
                error: null,
            };
        }

        case actions.UPDATE_MYCORE_CONFIG.FAILURE:
            return {
                ...state,
                updating: false,
                error: action.payload,
            };

        // Reset Configuration
        case actions.RESET_MYCORE_CONFIG.REQUEST:
            return { ...state, resetting: true, error: null };

        case actions.RESET_MYCORE_CONFIG.SUCCESS: {
            const { config } = action.payload;
            return {
                ...state,
                resetting: false,
                config,
                error: null,
            };
        }

        case actions.RESET_MYCORE_CONFIG.FAILURE:
            return {
                ...state,
                resetting: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default mycoreConfigReducer;
